/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Type_AudioInputs */

const en_media_type_audio = /** @type {(inputs: Media_Type_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High-Res Audio`)
};

const id_media_type_audio = /** @type {(inputs: Media_Type_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio Resolusi Tinggi`)
};

/** @type {(inputs: Media_Type_AudioInputs) => LocalizedString} */
const es_media_type_audio = en_media_type_audio;

/** @type {(inputs: Media_Type_AudioInputs) => LocalizedString} */
const fr_media_type_audio = en_media_type_audio;

/** @type {(inputs: Media_Type_AudioInputs) => LocalizedString} */
const de_media_type_audio = en_media_type_audio;

/** @type {(inputs: Media_Type_AudioInputs) => LocalizedString} */
const ja_media_type_audio = en_media_type_audio;

/** @type {(inputs: Media_Type_AudioInputs) => LocalizedString} */
const zh_media_type_audio = en_media_type_audio;

/** @type {(inputs: Media_Type_AudioInputs) => LocalizedString} */
const ar_media_type_audio = en_media_type_audio;

/** @type {(inputs: Media_Type_AudioInputs) => LocalizedString} */
const it_media_type_audio = en_media_type_audio;

/** @type {(inputs: Media_Type_AudioInputs) => LocalizedString} */
const ru_media_type_audio = en_media_type_audio;

/** @type {(inputs: Media_Type_AudioInputs) => LocalizedString} */
const pt_media_type_audio = en_media_type_audio;

/** @type {(inputs: Media_Type_AudioInputs) => LocalizedString} */
const ko_media_type_audio = en_media_type_audio;

/**
* | output |
* | --- |
* | "High-Res Audio" |
*
* @param {Media_Type_AudioInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const media_type_audio = /** @type {((inputs?: Media_Type_AudioInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Type_AudioInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_media_type_audio(inputs)
	if (locale === "es") return es_media_type_audio(inputs)
	if (locale === "fr") return fr_media_type_audio(inputs)
	if (locale === "de") return de_media_type_audio(inputs)
	if (locale === "ja") return ja_media_type_audio(inputs)
	if (locale === "zh") return zh_media_type_audio(inputs)
	if (locale === "ar") return ar_media_type_audio(inputs)
	if (locale === "id") return id_media_type_audio(inputs)
	if (locale === "it") return it_media_type_audio(inputs)
	if (locale === "ru") return ru_media_type_audio(inputs)
	if (locale === "pt") return pt_media_type_audio(inputs)
	return ko_media_type_audio(inputs)
});